import { render, staticRenderFns } from "./SpPreviewButton.vue?vue&type=template&id=bdb816a8"
import script from "./SpPreviewButton.vue?vue&type=script&lang=js"
export * from "./SpPreviewButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports